import { NgModule } from '@angular/core';
import { NgxUiLoaderHttpModule } from 'ngx-ui-loader';



@NgModule({
  
  imports: [
    NgxUiLoaderHttpModule.forRoot({ showForeground: true, exclude: ["api/Auth/refreshToken", "api/ColumnChange/Savewidth?", "api/ColumnChange/getwidth?", "api/Claims/checkClaimCreationProgressPurchase?", "api/Claims/checkClaimCreationProgress?", "api/Claims/checkClaimCreationProgressTransaction?"] }),
   
  ],
  
  declarations: [      
  
  ],
})
export class PagesModule { }
